import { render, staticRenderFns } from "./DeliverySearchBar.vue?vue&type=template&id=183cd3ae"
import script from "./DeliverySearchBar.vue?vue&type=script&lang=js"
export * from "./DeliverySearchBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports